function adminKycManagement() {
	let kycManagement = [
		{
			name: "Kyc Management",
			icon: "Kyc-management",
			logoName: "MyAccounts",
			// flag: "voucherRequired",
			displayService: "adminKycManagement",
			items: []
		}
	];

	const dashboard = () => {
		const dashboardArr = [
			{
				path: "/index/AdminKyc-Management",
				name: "Dashboard",
				icon: "dashboard",
				logoName: "dashboard",
				flag: "DASHBOARD",
			}
		];

		return dashboardArr;
	};

	const createProofType = () => {
		const profileArr = [
			{
				path: "/index/CreateProofType",
				name: "Create Proof Type",
				icon: "CreateProofType",
				logoName: "CREATE PROOF TYPE",
				flag: "CREATE PROOF TYPE"
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(kycSettings.data[profileArr[0].flag])
		// ) {
		return profileArr;
		// } else {
		//   return "";
		// }
	};

	const createDocumentType = () => {
		const profileArr1 = [
			{
				path: "/index/CreateDocumentType",
				name: "Create Document Type",
				icon: "CreateDocumentType",
				logoName: "CREATE DOCUMENT TYPE",
				flag: "CREATE DOCUMENT TYPE"
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(kycSettings.data[profileArr[0].flag])
		// ) {
		return profileArr1;
		// } else {
		//   return "";
		// }
	};

	const kycMapping = () => {
		const profileArr2 = [
			{
				path: "/index/KycMapping",
				name: "KYC Mapping",
				icon: "KycMapping",
				logoName: "kyc configration",
				flag: "KYC MAPPING"
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(kycSettings.data[profileArr[0].flag])
		// ) {
		return profileArr2;
		// } else {
		//   return "";
		// }
	};

	const kycReport = () => {
		const profileArr3 = [
			{
				path: "/index/KycReport",
				name: "KYC Report",
				icon: "kycReport",
				logoName: "kyc report",
				flag: "KYC REPORT",

				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(kycSettings.data[profileArr[0].flag])
		// ) {
		return profileArr3;
		// } else {
		//   return "";
		// }
	};

	const kybReport = () => {
		const profileArr4 = [
			{
				path: "/index/KybReport",
				name: "KYB Report",
				icon: "kybReport",
				logoName: "kyb report",
				flag: "KYB REPORT",
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(kycSettings.data[profileArr[0].flag])
		// ) {
		return profileArr4;
		// } else {
		//   return "";
		// }
	};

	let a = dashboard();
	let b = createProofType();
	let c = createDocumentType();
	let d = kycMapping();
	let e = kycReport();
	let f = kybReport();

	kycManagement[0].items = [...a, ...b, ...c, ...d, ...e, ...f];

	return kycManagement;
}

export default adminKycManagement;
